/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { CustomSearchClientContext } from "./customSearchClientContext";

class CustomSearchClient extends CustomSearchClientContext {
  // Operation groups
  customInstance: operations.CustomInstance;

  /**
   * Initializes a new instance of the CustomSearchClient class.
   * @param credentials Subscription credentials which uniquely identify client subscription.
   * @param [options] The parameter options
   */
  constructor(credentials: msRest.ServiceClientCredentials, options?: Models.CustomSearchClientOptions) {
    super(credentials, options);
    this.customInstance = new operations.CustomInstance(this);
  }
}

// Operation Specifications

export {
  CustomSearchClient,
  CustomSearchClientContext,
  Models as CustomSearchModels,
  Mappers as CustomSearchMappers
};
export * from "./operations";
